export default function Philosophy() {
  return (
    <section className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center space-y-16">
          {/* Section Title */}
          <div className="space-y-6">
            <h2 className="text-5xl lg:text-6xl font-light text-gray-900 tracking-tight">
              Better Water, Better World
            </h2>
            <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
              Heritage Water의 시작은 "좋은 물이란 무엇인가?"라는 질문입니다.<br />
              우리는 더 나은 물이 결국 더 나은 세상을 만든다고 믿습니다.
            </p>
          </div>

          {/* Three Pillars */}
          <div className="grid md:grid-cols-3 gap-8 pt-8">
            {/* Better Water */}
            <div className="bg-white rounded-3xl shadow-lg p-10 border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-20 h-20 mx-auto flex items-center justify-center bg-teal-50 rounded-full mb-6">
                <i className="ri-drop-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-medium text-gray-900 mb-4">Better Water</h3>
              <p className="text-sm text-teal-600 font-medium mb-4">자연이 만든 가장 순수한 물</p>
              <p className="text-gray-600 font-light leading-relaxed">
                원수 자체의 품질을 기준으로 삼으며, 자연이 만들어낸 미네랄 밸런스를 그대로 유지합니다. 자연 그대로의 순수함을 흐트러뜨리지 않는 물입니다.
              </p>
            </div>

            {/* Better Material */}
            <div className="bg-white rounded-3xl shadow-lg p-10 border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-20 h-20 mx-auto flex items-center justify-center bg-teal-50 rounded-full mb-6">
                <i className="ri-recycle-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-medium text-gray-900 mb-4">Better Material</h3>
              <p className="text-sm text-teal-600 font-medium mb-4">플라스틱보다 더 나은 선택</p>
              <p className="text-gray-600 font-light leading-relaxed">
                깨끗한 물은 깨끗한 용기에서 완성됩니다. 100% 재활용 가능한 알루미늄 캔만 사용하는 것은 더 나은 물을 제공하기 위한 책임감 있는 선택입니다.
              </p>
            </div>

            {/* Better World */}
            <div className="bg-white rounded-3xl shadow-lg p-10 border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="w-20 h-20 mx-auto flex items-center justify-center bg-teal-50 rounded-full mb-6">
                <i className="ri-earth-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-medium text-gray-900 mb-4">Better World</h3>
              <p className="text-sm text-teal-600 font-medium mb-4">작은 선택이 만드는 큰 변화</p>
              <p className="text-gray-600 font-light leading-relaxed">
                물 한 병이 세상을 바꾸기는 어렵지만, 우리는 더 나은 선택을 지속적으로 만듭니다. 작은 선택이 환경을 바꾼다고 믿습니다.
              </p>
            </div>
          </div>

          {/* Core Values */}
          <div className="bg-gradient-to-br from-teal-50 to-white rounded-3xl shadow-xl p-12 border border-teal-100 mt-16">
            <h3 className="text-3xl font-light text-gray-900 mb-10">우리의 약속</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
              <div className="text-center space-y-3">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-plant-line text-2xl text-teal-600"></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">플라스틱 사용량<br />감소</p>
              </div>
              
              <div className="text-center space-y-3">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-loop-right-line text-2xl text-teal-600"></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">무한 재활용<br />가능한 소재</p>
              </div>
              
              <div className="text-center space-y-3">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-eye-line text-2xl text-teal-600"></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">투명한<br />제조 과정</p>
              </div>
              
              <div className="text-center space-y-3">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-landscape-line text-2xl text-teal-600"></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">산지와 자연<br />보호</p>
              </div>
              
              <div className="text-center space-y-3">
                <div className="w-14 h-14 mx-auto flex items-center justify-center bg-white rounded-full shadow-md">
                  <i className="ri-heart-line text-2xl text-teal-600"></i>
                </div>
                <p className="text-sm text-gray-700 font-medium">과장 없는<br />정직함</p>
              </div>
            </div>
          </div>

          {/* Closing Message */}
          <div className="pt-8">
            <p className="text-2xl lg:text-3xl font-light text-gray-800 italic leading-relaxed">
              "더 나은 물이 결국 더 나은 세상을 만듭니다"
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
